import { NotificationAction, NotificationActionTypes, NotificationState } from './types';

const initialState: NotificationState = [];

export const notificationReducer = (
  state: NotificationState = initialState,
  action: NotificationActionTypes,
): NotificationState => {
  switch (action.type) {
    case NotificationAction.ADD_NOTIFICATION: {
      return [
        ...state,
        {
          ...action.payload,
        },
      ];
    }
    case NotificationAction.REMOVE_NOTIFICATION: {
      return state.filter((item) => item.id !== action.payload);
    }
    case NotificationAction.UPDATE_NOTIFICATION: {
      return state.map((item) => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            ...action.payload,
          };
        }
        return item;
      });
    }
    default: {
      return state;
    }
  }
};
